<template>
  <div>
    <div class="text-weight-bold">Unidade</div>
    <q-select
      v-model="unidade"
      :options="listaUnidades"
      @filter="filterFn"
      @input-value="setModel"
      use-input
      dense
      outlined
      map-options
      option-label="unidade"
      option-value="unidadeId"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhuma unidade encontrado
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch, onMounted } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["enviarUnidade"]);
const props = defineProps(["clienteId", "resetar", "model", "unidadeId"]);

const store = useStore();
const time = ref();
const unidade = ref(props.model);
const listaUnidades = ref([]);

const listarUnidades = async (val) => {
  listaUnidades.value = [];
  if (props.clienteId === "" || props.clienteId == undefined) {
    return;
  }
  try {
    const response = await store.dispatch("office/listarUnidadesPorCliente", {
      clienteId: props.clienteId,
    });
    listaUnidades.value = response.data.resultado.dados.filter((unidade) => {
      return unidade.unidade.toLowerCase().includes(val.toLowerCase());
    });
  } catch (error) {
    console.log(error);
  }
};

const verificarUnidadeId = async () => {
  if (props.unidadeId === "" || props.unidadeId == undefined) {
    return;
  }
  try {
    const response = await store.dispatch("office/listarUnidadesPorCliente", {
      clienteId: props.clienteId,
    });

    const array = response.data.resultado.dados.filter((unidade) => {
      return unidade.unidadeId == props.unidadeId;
    });
    unidade.value = array[0];
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  verificarUnidadeId();
});

watch(
  () => unidade.value,
  () => {
    if (unidade.value != "") {
      emit("enviarUnidade", unidade.value);
    }
  }
);

watch(
  () => props.model,
  () => {
    unidade.value = props.model;
  }
);

watch(
  () => props.resetar,
  () => {
    unidade.value = "";
  }
);

watch(
  () => props.clienteId,
  () => {
    if (props.clienteId != unidade.value?.clienteId) {
      unidade.value = "";
    }
  }
);

function filterFn(val, update) {
  clearTimeout(time.value);

  time.value = setTimeout(() => {
    listarUnidades(val);
  }, 2000);

  setTimeout(() => {
    update();
  }, 2500);
}

function setModel(val) {
  if (val === "") {
    unidade.value = val;
  }
}
</script>
